import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useMsal } from '@azure/msal-react';
import { useDispatch, useSelector } from 'react-redux';
import { clearUserData } from '../../store/slices/userSlice';
import './noAccess.css';

const NoAccess = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const dispatch = useDispatch();
  const errorCode = useSelector((state) => state.user.errorCode);

  const handleLogin = async () => {
    try {
      await instance.logoutRedirect();
      localStorage.clear();
      dispatch(clearUserData());
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
      // Even if logout fails, clear local state and redirect
      localStorage.clear();
      dispatch(clearUserData());
      navigate('/');
    }
  };
  const renderMessage = () => {
    if (errorCode === 404) {
      return {
        title: 'User Not Found',
        message: "Apologies, it appears this account doesn't exist. Please reach out to Admin or HR for further assistance."
      };
    }
    if (errorCode === 403) {
      return {
        title: 'Permission Denied',
        message: "Apologies, it appears you don't have permission to access the Timesheet app. Please reachout to Admin/HR for future assistance."
      };
    }
    return {
      title: 'Session Expired',
      message: 'Your session has expired. Please log in again.'
    };
  };

  const { title, message } = renderMessage();
  return (
    <div className="no-access-container">
      <div className="no-access-content">
        <i className="pi pi-lock text-6xl text-red-500 mb-4"></i>
        <h1>{title}</h1>
        <p>{message}</p>
        <Button 
          label="Return to Login" 
          icon="pi pi-sign-in" 
          onClick={handleLogin}
          className="p-button-primary mt-4"
        />
      </div>
    </div>
  );
};

export default NoAccess;
